exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_PicaEvents__-66UY h4 {\n  margin: 10px 0 20px;\n  border-bottom: 4px solid #000;\n  font-size: 2.1em; }\n", ""]);

// Exports
exports.locals = {
	"PicaEvents": "styles_PicaEvents__-66UY"
};